// extracted by mini-css-extract-plugin
export default {"imgContainer":"PostItem_imgContainer__C1ICB","content":"PostItem_content__VfDbC","btn":"PostItem_btn__kO2Zr"};